<template>
  <div v-if="!search" class="cat-nav">
    <button
      v-for="c in categories"
      :key="c.id"
      @click="$emit('update:category', c.id)"
      class="cat-tab"
      :class="{ 'cat-tab--active': category === c.id }"
    >
      {{ c.name }}
    </button>
  </div>
</template>

<script setup>
defineProps({
  category:   { type: String, required: true },
  search:     { type: String, default: '' },
  categories: { type: Array,  default: () => [] },
})

defineEmits(['update:category'])
</script>

<style scoped>
.cat-nav {
  display: flex;
  gap: 4px;
  padding: 0 24px;
  background: var(--surface);
  border-bottom: 1px solid var(--border);
  overflow-x: auto;
  flex-shrink: 0;
}

.cat-tab {
  padding: 12px 14px;
  background: none;
  border: none;
  border-bottom: 2px solid transparent;
  cursor: pointer;
  color: var(--text-2);
  font-family: var(--ff-body);
  font-size: 13px;
  font-weight: 500;
  white-space: nowrap;
  transition: color 0.15s, border-color 0.15s;
}

.cat-tab--active {
  border-bottom-color: var(--primary);
  color: var(--text);
  font-weight: 700;
}
</style>
